'use client';
import ProAnalytics, {
	ProAnalyticsEventCustomProps,
} from '@/utils/analytics/analytics';
import { useEffect, useMemo, useState } from 'react';
import { ANALYTICS_URL } from '@/app-preferences';
import User from '@/types/User';

const defaultUser: User = {
	userType: 'guest',
	id: 75,
	isProfessional: false,
};

interface AnalyticsProps {
	referrer: string;
	common?: ProAnalyticsEventCustomProps;
	pushPageView?: boolean;
}

const useAnalytics = (data: AnalyticsProps) => {
	const [isClient, setIsClient] = useState(false);
	useEffect(() => {
		setIsClient(true);
	}, []);

	return useMemo(() => {
		if (!isClient) return null;
		const { common, pushPageView = false, referrer } = data;
		const windowExists = typeof window == 'undefined';
		const href = windowExists ? '' : window.location.href;
		const userAgent = windowExists ? '' : window.navigator.userAgent;
		return new ProAnalytics({
			isBot: userAgent.toLowerCase().includes('bot'),
			statusCode: 200,
			urlReferrer: referrer,
			href: href,
			user: defaultUser,
			apiUrl: ANALYTICS_URL,
			commonPushData: common,
		}).start(pushPageView);
	}, [isClient]);
};

export const AnalyticsViewPush = ({ referrer }: { referrer: string }) => {
	useAnalytics({
		pushPageView: true,
		referrer: referrer,
	});
	return null;
};
export default useAnalytics;
